import React from "react";
import '../style/Maincontact.css';
import { ToothZapFooter } from "../layouts/footer";
import { Nav } from '../layouts/header';
const Contact = () => {
  return (
  <div className="contact-page">

  <Nav />

  <div className="container-fluid">

    <div className="row g-0 g-lg-4 pb-5 mx-3"> 
    <h1 className="contact-title pt-5">Contact ToothZap</h1>


      <div className="col-md-5 col-12 pt-3">
        <div className="contact-left">
          <h3>Get in touch</h3>
          <p>New Delhi, India</p>
          <p>hello@toothzap.in</p>
          <p>+91-00000-00000</p>
        </div>
      </div>

      <div className="col-md-7 col-12 pt-3">
        <div className="contact-right">
          <form>
            <div className="form-group contact-form-input">
              <label className="form-label">Name</label>
              <input type="text" placeholder="Your name" />
            </div>

            <div className="form-group contact-form-input">
              <label className="form-label">Email</label>
              <input type="email" placeholder="you@example.com" />
            </div>

            <div className="form-group contact-form-input">
              <label className="form-label">Message</label>
              <textarea placeholder="How can we help?" className="message-textarea"></textarea>
            </div>

            <button className="submit-btn">Submit</button>
            <p className="response-text">
              We usually respond within one business day.
            </p>
          </form>
        </div>
      </div>

    </div>
  </div>

  <ToothZapFooter />

</div>
    
  );
};

export default Contact;